import React from 'react';
import PageHeader from '../components/PageHeader.tsx';
import EmptyState from '../components/EmptyState.tsx';
import { Folder24Regular } from '@fluentui/react-icons';

export default function Files() {
  return (
    <div>
      <PageHeader title="File Management" subtitle="Manage uploaded files and logs" />
      <div style={{ backgroundColor: 'var(--color-surface)', border: '1px solid var(--color-border-light)', borderRadius: 'var(--radius-md)', padding: 'var(--space-lg)' }}>
        <EmptyState icon={<Folder24Regular />} title="Coming soon" description="File management is under development" />
      </div>
    </div>
  );
}
